import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PrimarySubject from '../../static/images/icons/icon_subject.svg'
import PrimarySubjectVictoria from '../../static/images/icons/icon_subject_victoria.svg'
import FlexAlignCenter from '../styled/FlexAlignCenter'
import { optionallyStyled } from '../../utils/stylecomponents'
import { Caption1 } from '../styled/typography/typography'

const Icon = styled.img.attrs(props => ({
  src: props.dark
    ? PrimarySubjectVictoria
    : PrimarySubject
}))`
  height: ${props => props.size};
  width: ${props => props.size};
  margin-right: 7px;
  box-shadow: none;
`

const QuestSubject = props => {
  const Component = optionallyStyled(props.styleComponent)
  return (
    <FlexAlignCenter>
      <Icon dark={props.dark} size={props.size} />
      <Component className={props.textClass} {...props.textProps}>
        {props.subject}
      </Component>
    </FlexAlignCenter>
  )
}

QuestSubject.defaultProps = {
  styleComponent: Caption1,
  size: '11px'
}

QuestSubject.propTypes = {
  subject: PropTypes.object,
  textClass: PropTypes.string,
  styleComponent: PropTypes.elementType,
  dark: PropTypes.bool,
  size: PropTypes.string,
  textProps: PropTypes.object
}

export default QuestSubject
